import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    drawerItemIcon: {
        width: `24px !important`,
        height: `24px !important`,
        color: `${theme.palette.menu.icons.main} !important`,
    },
    drawerItem: {
        "& .MuiListItemIcon-root": {
            minWidth: `32px !important`,
        },
        "&:hover": {
            backgroundColor: `${theme.palette.secondary.main} !important`,
            color: `${theme.palette.info.main} !important`,
        },
    },
    drawerItemText: {
        marginLeft: 4,
        "& span": {
            fontFamily: "Open Sans !important",
            fontWeight: "400 !important",
            fontSize: "14px !important",
            color: `${theme.palette.menu.icons.main} !important`,
        },
    },
    drawerItemTextNoData: {
        marginLeft: 4,
        "& span": {
            fontFamily: "Open Sans !important",
            fontWeight: "400 !important",
            fontSize: "14px !important",
            color: `${theme.palette.primary.dark} !important`,
        },
    },
    drawerItemSelected: {
        backgroundColor: `${theme.palette.secondary.main} !important`,
        color: `${theme.palette.info.main} !important`,
    },
    loadingMenu: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "30px 0",
        width: "100%",
        fontFamily: "Open Sans !important",
        fontWeight: "400 !important",
        fontSize: "12px !important",
        color: `${theme.palette.primary.dark} !important`,
    },
    chevronIcon: {
        width: `16px !important`,
        height: `16px !important`,
    },
}));
